module.exports = __webpack_public_path__ + "img/j1@2x.c90a1521.png";